export enum SubRoleType {
    SalariedGP = 1,
    GPPartner = 2,
    LocumGP = 3,
    Academic = 4
}
